$.eachComponent('.firms_score_dialog', function(context) {
    var _default = $('select[name="fk_customers_criteria"]', context).data('default');
    var _weight = $('select[name="fk_customers_criteria"]', context).data('weight');
    $('select[name="fk_customers_criteria"]', context).change(function() {
        $('input[name="value"]', context).val(_default[$(this).val()]);
        $('input[name="weight"]', context).val(_weight[$(this).val()]);
    });
    
    $('select[name="fk_customers_criteria"]', context).change();
});